import { render, staticRenderFns } from "./pvTabPane.vue?vue&type=template&id=0885bdc4&scoped=true"
import script from "./pvTabPane.vue?vue&type=script&lang=js"
export * from "./pvTabPane.vue?vue&type=script&lang=js"
import style0 from "./pvTabPane.vue?vue&type=style&index=0&id=0885bdc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.99.6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885bdc4",
  null
  
)

export default component.exports